/** Centralised clinic branding — change here once, applies everywhere. */
export const CLINIC = {
  name: "The Holistic Homoeopathy Clinic",
  shortName: "The Holistic",
  tagline: "Reviving Health Naturally",
  logoUrl: "https://customer-assets.emergentagent.com/job_homeo-care-10/artifacts/jzh48k6n_Holistic%20logo.png",
  doctor: "Dr Harleen S Kaur",
  doctorTitle: "BHMS, MD (Hom)",
  city: "Mumbai",
  country: "India",
  phone: "+91-9819737002",
  email: "hello@holisticclinic.com",
  address: "Shop No 1, Rajendra Vihar, Next To Ryan International School (CBSE), Evershine Nagar, Malad West, Mumbai - 400064",
};
